import {
  enableProdMode,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncDocumentModule as MncDocumentModule } from './app/mnc-document.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('Document.MFE UI Version:', {
  buildNumber,
  commit,
});

platformBrowserDynamic()
  .bootstrapModule(MncDocumentModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
